import React, { useEffect, useState, useMemo, useRef } from 'react'
import { CSSTransition } from 'react-transition-group'

import { useAdStat } from 'Components/ad'
import applyHttpsImage from 'lib/apply-https-img'

import Label from './label'
import { PcCommonBannerAd } from './interface'
// 页面顶部的通栏广告
export default function TonglanAd({ data }: { data: PcCommonBannerAd }) {
  const [expaned, setExpaned] = useState(false)
  // const adData = useMemo(() => {
  //   return {
  //     ad_material_id: data.materiel_str,
  //     ad_target_url: data.web_url,
  //     log_extra: data.log_extra,
  //     ad_id: data.id_str,
  //     ad_req_id: JSON.parse(data.log_extra).req_id,
  //   }
  // }, [data.id_str, data.log_extra, data.materiel_str, data.web_url])
  const timer = useRef<number>()
  const { ref, handleClick } = useAdStat(
    {
      send: 'ad_send_home_page_top_banner',
      show: 'ad_show_home_page_top_banner',
      click: 'ad_click_home_page_top_banner',
    },
    data,
    undefined,
    6000
  )
  if (!data) return null
  return (
    <>
      <div
        className={`banner ${expaned ? 'expaned' : ''}`}
        onMouseEnter={() => {
          timer.current = window.setTimeout(() => {
            setExpaned(true)
          }, 200)
        }}
        onMouseLeave={() => {
          clearTimeout(timer.current)
          setExpaned(false)
        }}
        ref={ref}
      >
        <a
          onClick={() => {
            handleClick()
            window.open(data.web_url, '_blank')
          }}
        >
          <img src={applyHttpsImage(data.image.url)} />
          {/** 车展广告隐藏广告标签 */}
          {data.web_url.indexOf('car_show') > -1 ? null : (
            <Label text={data.label} />
          )}
        </a>
        {data.image_expand ? (
          <CSSTransition
            in={expaned}
            unmountOnExit
            timeout={700}
            classNames="expand"
          >
            <a
              onClick={() => {
                handleClick()
                window.open(data.web_url, '_blank')
              }}
              className="expand"
            >
              <img src={applyHttpsImage(data.image_expand.url)} />
              {/* pc广告优化，展开广告去掉广告标签 */}
            </a>
          </CSSTransition>
        ) : null}
      </div>
      <style global jsx>
        {`
          .expand-enter {
            max-height: 0;
            border-radius: 2px;
            width: 1196px;
          }
          .expand-enter-active {
            max-height: 500px;
            transition: max-height 700ms ease-in-out;
            width: 1196px;
          }
          .expand-exit {
            max-height: 500px;
            width: 1196px;
          }
          .expand-exit-active {
            max-height: 0;
            transition: max-height 700ms ease-in-out;
            width: 1196px;
          }
        `}
      </style>
      <style jsx>
        {`
          .banner {
            position: relative;
            width: 1196px;
          }
          a {
            margin: 10px 0;
            display: block;
            position: relative;
          }
          .expand {
            overflow: hidden;
            will-change: max-height;
            transform: translateZ(0);
          }
          img {
            vertical-align: middle;
            max-width: 100%;
            border-radius: 2px;
            width: 1196px;
          }
        `}
      </style>
    </>
  )
}
